import TotalCosmeticContainer from "./TotalCosmeticContainer";

export default TotalCosmeticContainer;
